import { render, staticRenderFns } from "./TabExample.vue?vue&type=template&id=20a4aae6&scoped=true"
import script from "./TabExample.vue?vue&type=script&lang=js"
export * from "./TabExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a4aae6",
  null
  
)

export default component.exports